const { CivilCardTypes, MilitaryCardTypes, CardDeck } = require('@tta/engine/Constants/Constants')
const { GameColors } = require('../Constants/Constants');

function GetCardColor(card)
{
    if (card === undefined || card === null)
        return 'lightgrey';
    if (card.deck === CardDeck.Military)
    {
        switch(card.type) {
            case MilitaryCardTypes.Aggression:
                return "#733712";
            case MilitaryCardTypes.Bonus:
                return "#124b55";
            case MilitaryCardTypes.Pact:
                return "#020d7f";
            case MilitaryCardTypes.Tactic:
                return "#8d1108";
            case MilitaryCardTypes.War:
                return "black";
            default:
                return "#75750e"
        }
    }
    switch(card.type) {
        case CivilCardTypes.Action:
            return "yellow";
        case CivilCardTypes.Leader:
            return "green";
        case CivilCardTypes.Wonder:
            return "purple";
        default: // CardTypes.CivilCardTypes.Technology
            switch(card.category) {
                case "Farm":
                case "Mine":
                    return GameColors.TechnologyColors.Production;
                case "Construction":
                case "Colonization":
                case "Military":
                case "Civil":
                    return GameColors.TechnologyColors.Special;
                case "Air Forces":
                case "Artillery":
                case "Cavalry":
                case "Infantry":
                    return GameColors.TechnologyColors.Military;
                case "Government":
                    return GameColors.TechnologyColors.Government;
                default:
                    return "grey";
            }
    }
}

function GetOpposedTextColor(card)
{
    if (card === undefined || card === null)
        return 'white';
    switch(card.type) {
        case CivilCardTypes.Action:
            return "black";
        case CivilCardTypes.Leader:
            return "black";
        case CivilCardTypes.Wonder:
            return "white";
        default: // CardTypes.CivilCardTypes.Technology
            switch(card.category) {
                case "Farm":
                case "Mine":
                case "Construction":
                case "Colonization":
                case "Military":
                case "Civil":
                case "Air Forces":
                case "Artillery":
                case "Cavalry":
                case "Infantry":
                    return "white";
                case "Government":
                    return "black";
                default:
                    return "white";
            }
    }
}

// A thin white outline around dark text, so it stays readable on a card's dark colors (a farm's brown, a wonder's
// purple): tight white blurs, doubled, firmer than a glow but softer than a hard 1-pixel outline (also in index.css as
// --tta-white-outline)
const WhiteOutline = '0 0 1px #fff, 0 0 1px #fff, 0 0 2px #fff, 0 0 2px #fff';

module.exports = {
    GetCardColor,
    GetOpposedTextColor,
    WhiteOutline,
}